import { render } from "./ErrorContent.vue?vue&type=template&id=5f71b3ec&scoped=true&ts=true"
import script from "./ErrorContent.vue?vue&type=script&lang=ts"
export * from "./ErrorContent.vue?vue&type=script&lang=ts"

import "./ErrorContent.vue?vue&type=style&index=0&id=5f71b3ec&scoped=true&lang=css"

import exportComponent from "E:\\Code\\hjp\\yijian-proxy-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f71b3ec"]])

export default __exports__